import { ref } from 'vue';

const employeeBonusProfilesHandler = () => {
  const employeeBonusProfiles_error = ref(null);
  const allEmployeeBonusProfiles = ref(null);

  const loadAllEmployeeBonusProfiles = async (employerId) => {
    try {
      var params = [['employer_id', employerId]];

      let data = await fetch("/api/employeebonusprofiles?" + new URLSearchParams(params));

      if (!data.ok) {
        throw Error("Can't load data");
      }

      allEmployeeBonusProfiles.value = await data.json();

      //console.log('projects', projects.value);
    } catch (err) {
      employeeBonusProfiles_error.value = err.message;
    }
  }

  return { allEmployeeBonusProfiles, employeeBonusProfiles_error, loadAllEmployeeBonusProfiles };
};

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

export default employeeBonusProfilesHandler;
